export default __webpack_public_path__ + "static/media/Lavender-Bottle.cd9fb615.png";